module.exports = __webpack_public_path__ + "img/plat_4899.a99d35c2.jpg";